import React from 'react'

import { strings } from 'context/LanguageContext/strings'
import { getCDNURL } from 'network/api/networkSettings'

const ErrorScreen = ({ renderFailure }) => {
    const problem = getCDNURL() + 'assets/images/problem.webp'

    return (
        <section className="container">
            <div className={'errorScreen'}>
                {renderFailure ? (
                    <p>{strings.errorScreenMsg1}</p>
                ) : (
                    <>
                        <img src={problem} alt={strings.problem}></img>
                        <p>{strings.errorScreenMsg1}</p>
                    </>
                )}

                {renderFailure ? (
                    <div className={'errorScreen-msg'}>
                        <p>{strings.errorScreenMsg4}</p>
                    </div>
                ) : (
                    <div className={'errorScreen-msg'}>
                        <p>{strings.errorScreenMsg2}</p>
                        <p>{strings.errorScreenMsg3}</p>
                    </div>
                )}
            </div>
        </section>
    )
}

export default ErrorScreen
